<template>
    <div class="mobile">
        <div class="mobile-register">
            <div style="display: flex; justify-content: space-between;">
                <div class="return"><img v-if="step !== 1" @click="backStep" src="@/assets/img/return.png" /></div>
                <div class="close"><router-link to="/"><i class="iconfont icon-a-close-line1"></i></router-link></div>
            </div>

            <div class="signin">
                <h4>{{ $t('Home.Register.SignUp') }}</h4>
                <p>{{ $t('Home.Register.Tips1') }} <router-link class="login" to="/login">{{ $t('Home.Register.SignIn') }}</router-link></p>
            </div>

            <div class="step-tab f-b-c">
              <div class="item f-c-c sel">{{ $t('Home.Register.Tips2') }}</div>
              <div class="item f-c-c" :class="{ sel: step === 5 }">{{ $t('Home.Register.Tips3') }}</div>
            </div>

            <div v-show="step <= 3" class="register-question">
              <RegisterQuestion ref="registerQuestion" :step="step" @selectQuestion="selectQuestion"></RegisterQuestion>
              <el-button :disabled="step <= 3 && !questions['question' + this.step]" type="primary" class="register-btn" @click="handleNext">{{ $t('Home.Login.Continue') }} <i class="el-icon-right"></i></el-button>
            </div>
            <div v-show="step === 4" class="register-info">
              <el-form label-position="top" label-width="80px" ref="resetBusiness" :model="business">
                  <el-input v-model.trim="business.brandName" :placeholder="$t('Home.Register.BrandName')"></el-input>
                  <el-input v-model.trim="business.websiteURL" :placeholder="$t('Home.Register.WebsiteURL')"></el-input>

                  <div style="position: relative; margin: 0 0 24px;">
                    <el-input v-model.trim="business.referrer" @click.native="show=true" :placeholder="$t('Home.Register.Referrer')" class="referrer" readonly="readonly"></el-input>
                    <i class="el-icon-arrow-down" @click="show=true" style="top: 41px; right: 8px; left: unset; position: absolute;"></i>
                  </div>
                  <van-action-sheet v-model="show" :actions="mtStatusList" @select="onSelect" :title="$t('Home.Register.Referrer')"></van-action-sheet>

                <el-form-item style="margin-bottom:0;">
                  <el-button type="primary" class="register-btn" @click="handleNext">{{ $t('Home.Login.Continue') }} <i class="el-icon-right"></i></el-button>
                </el-form-item>
              </el-form>
            </div>

            <div v-show="step === 5" class="register-info">
              <el-form label-position="top" label-width="80px" ref="userForm" :model="userForm" :rules="rules">
                <el-form-item prop="fullName">
                  <el-input v-model.trim="userForm.fullName" :placeholder="$t('Home.Register.FullName')" @input="checkRegisterBtn"></el-input>
                </el-form-item>
                <el-form-item v-if="loginMethod === 'email'" prop="email" class="username" key="email">
                    <el-input v-model.trim="userForm.email" :placeholder="$t('Home.Login.EmailID')" @input="checkRegisterBtn"></el-input>
                </el-form-item>
                <el-form-item v-else class="username">
                    <div class="login-mobile f--c">
                      <el-form-item>
                        <van-popup v-model="showPicker" position="bottom">
                          <van-picker show-toolbar :columns="areaCodeList" @confirm="checkAreaCode" @cancel="showPicker = false" cancel-button-text="Cancel" confirm-button-text="Confirm"/>
                        </van-popup>
                        <div style="position: relative;">
                            <el-input v-model.trim="areaCode" class="areaCode" readonly="readonly" @click.native="selectAreaCode"></el-input>
                            <i class="el-icon-arrow-down"  @click="selectAreaCode" style="top: 25px; right: 8px; left: unset;"></i>
                        </div>
                      </el-form-item>
                      <el-form-item prop="phone" class="phone" style="width: 100%;" key="phone">
                        <el-input v-model.trim="userForm.phone" :placeholder="$t('Home.Mobile.Login.PhoneNumber')" @input="checkRegisterPhone"></el-input>
                      </el-form-item>
                    </div>
                </el-form-item>
                <el-form-item prop="verificationCode" class="verificationCode">
                  <el-input v-model.trim="userForm.verificationCode"  style="width: 72%;" :placeholder="$t('Home.Mobile.Login.PleaseInputVerificationCode')"></el-input>
                    <el-button v-if="seconds===0" class="send" @click="getVertificationCode" :loading="sendLoading" :disabled="sendBtn">{{ $t('Home.Mobile.Login.Send') }}</el-button>
                    <el-button v-else class="send" :loading="sendLoading" :disabled="sendBtn">{{seconds}}S</el-button>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input type="password" class="password" value="" v-model.trim="userForm.password" :placeholder="$t('Home.Register.Password')" show-password autocomplete="new-password"></el-input>
                </el-form-item>
                <p style="margin:30px 0 20px;color:#909399;font-size:12px">{{ $t('Home.Register.PasswordCheckRule') }}</p>
                <el-form-item style="margin-bottom:0;">
                  <el-button type="primary" class="register-btn" :loading="loading" @click="handleSignUp('userForm')">{{ $t('Home.Login.Continue') }} <i class="el-icon-right"></i></el-button>
                </el-form-item>
              </el-form>
              <MobileLoginMethod :loginMethod="loginMethod" @changeLoginMethod="changeLoginMethod"></MobileLoginMethod>
            </div>
            <div class="terms">
              <el-checkbox v-model="checked" :class="{ showError }" @change="showError = false"></el-checkbox>
              {{ $t('Home.Register.Tips9') }}
              <span class="pointer color-green" @click="jump('/terms-conditions')">{{ $t('Home.Register.Tips10') }}</span>
              <span class="pointer color-green" @click="jump('/privacy-policy')">{{ $t('Home.Register.Tips11') }}</span>
              {{ $t('Home.Register.Tips12') }}
            </div>
        </div>
    </div>
</template>
<script>
import API from '@/api'

import ActionSheet from 'vant/lib/action-sheet'
import 'vant/lib/action-sheet/style'

import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import picker from 'vant/lib/picker'
import 'vant/lib/picker/style'

import RegisterQuestion from './components/RegisterQuestion.vue'
import MobileLoginMethod from './components/MobileLoginMethod.vue'

import _ from 'lodash'
import { encrypt, decrypt } from '@/util/encryp.js'
import googleLoginMixin from '../js/googleLogin.js'

import { checkEmail, sixNumber, hasCapital, hasLowercase, hasNumber, telephoneNumber, generalPhoneNumber } from '@/util/validate'

let validateEmail = (rule, value, callback) => {
  if (checkEmail(value)) {
    callback()
  } else {
    callback(new Error('Please enter your vaild email'))
  }
}
let validSixNumber = (rule, value, callback) => {
  if (sixNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter a six-digit verification code'))
  }
}
let checkPhoneNumber = (rules, value, callback) => {
  if (telephoneNumber(value) || generalPhoneNumber(value)) {
    callback()
  } else {
    callback(new Error('Please enter your valid phoneNumber'))
  }
}

export default {
  components: { 'van-popup': popup, 'van-picker': picker, RegisterQuestion, 'van-action-sheet': ActionSheet, MobileLoginMethod },

  mixins: [googleLoginMixin],
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('Home.Register.PasswordCheck1')))
      } else if (value.length < 8 || value.length > 20) {
        callback(new Error(this.$t('Home.Register.PasswordCheck2')))
      } else if (!hasCapital(value) || !hasLowercase(value) || !hasNumber(value)) {
        callback(new Error(this.$t('Home.Register.PasswordCheck3')))
      } else {
        callback()
      }
    }
    return {
      step: 1,
      checked: false,
      questions: {
        question1: '',
        question2: '',
        question3: ''
      },
      business: {
        brandName: '',
        websiteURL: '',
        referrer: ''
      },
      show: false,
      mtStatusList: [
        { name: 'Google Search', value: 1 },
        { name: 'Shopify App Store', value: 2 },
        { name: 'Youtube', value: 3 },
        { name: 'FaceBook/Instagram', value: 4 },
        { name: 'Blog Mentioned', value: 5 },
        { name: 'Other', value: 6 }
      ],
      showError: false,
      loginMethod: 'email',
      areaCode: '+1',
      userForm: {
        fullName: '',
        email: '',
        phone: '',
        password: '',
        verificationCode: '',
        userRole: 1,
        userSource: 'google'
      },
      loading: false,
      seconds: 0,
      areaCodeList: [],
      sendLoading: false,
      showPicker: false,
      sendBtn: true,
      loadingSendBtn: false,
      username: '',
      password: '',
      new_password: '',
      captcha: '',
      errorMessage: '',
      rules: {
        fullName: [{ required: true, message: this.$t('Home.Register.FullNameCheck1'), trigger: 'blur' }, { min: 2, max: 255, trigger: 'blur', message: this.$t('Home.Register.FullNameCheck2') }],
        email: [{ validator: validateEmail, trigger: 'blur' }, { required: true, message: 'Please enter your vaild email', trigger: 'blur' }],
        phone: [{ validator: checkPhoneNumber, trigger: 'blur' }, { required: true, message: 'Please enter your vaild Phone Number', trigger: 'blur' }],
        verificationCode: [{ validator: validSixNumber, trigger: 'blur' }, { required: true, message: 'Please enter your vaild email', trigger: 'blur' }],
        password: [{ required: true, validator: validatePass, trigger: 'blur' }]
      }
    }
  },

  created() {
    // this.checkBtn()
    this.systemAddressInfo()
  },

  methods: {
    // 校验输入的电话号码（只能为数字）
    checkPhone() {
      this.userForm.phone = this.userForm.phone.replace(/\D/g, '')
    },
    backStep() {
      if (this.step === 4 && this.questions.question1 === 2) {
        this.step = 1
        return
      }
      if (this.step <= 1) return
      this.step--
    },
    selectQuestion(type, value) {
      this.$set(this.questions, `question${type}`, value)
    },
    handleNext() {
      if (this.step === 1 && this.questions.question1 === 2) {
        this.step = 4
        this.questions.question2 = ''
        this.questions.question3 = ''
        this.$refs.registerQuestion.question2 = '-1'
        this.$refs.registerQuestion.question3 = '-1'
        return
      }

      if (this.step === 4) {
        this.userForm.fullName = ''
        this.userForm.email = ''
        this.userForm.phone = ''
        this.userForm.password = ''
        this.userForm.verificationCode = ''
      }
      if (this.step >= 5) return
      this.step++
    },
    changeLoginMethod(method) {
      this.loginMethod = this.loginMethod === 'email' ? 'mobile' : 'email'
      this.username = ''
      this.password = ''
      this.loginBtn = true
      this.$refs.userForm.clearValidate()
    },
    onSelect(item) {
      this.show = false
      this.business.referrer = item.name
    },
    checkAreaCode(v) {
      this.areaCode = v
      this.showPicker = false
    },
    selectAreaCode() {
      this.showPicker = true
    },
    checkRegisterBtn() {
      this.sendBtn = !(this.userForm.fullName && (this.userForm.phone || this.userForm.email))
    },
    checkRegisterPhone() {
      this.userForm.phone = this.userForm.phone.replace(/\D/g, '')
      this.checkRegisterBtn()
    },
    systemAddressInfo() {
      API.systemAddressInfo().then(res => {
        let code = []
        res.data.forEach(function(v) {
          code.push(v.areaCode)
        })
        this.areaCodeList = code
      })
    },
    // 获取验证码
    getVertificationCode() {
      if (!this.checked) {
        this.showError = true
        return this.$message.warning(this.$t('promptText.msg50'))
      }
      this.sendLoading = true
      let data = { fullName: this.userForm.fullName }
      this.loginMethod === 'email' ? data.email = this.userForm.email : data.phone = `${this.areaCode} ${this.userForm.phone}`

      API.getEmailAuthentication(data).then(res => {
        if (res.code !== 10000) return this.$message.warning(res.message)
        this.hasCode = true
        this.seconds = 60
        this.timer = setInterval(() => {
          if (this.seconds <= 0) {
            clearInterval(this.timer)
            this.timer = null
            this.$forceUpdate()
            return
          }
          --this.seconds
        }, 1000)
        this.$message.success(this.$t('promptText.msg28'))
      }).catch(result => {
        this.$message.error(result.data.message)
      }).finally(() => {
        this.sendLoading = false
      })
    },
    // 注册
    handleSignUp(userForm) {
      if (!this.checked) {
        this.showError = true
        return this.$message.error(this.$t('promptText.msg50'))
      }

      this.$refs.userForm.validate(valid => {
        if (!valid) return

        let form = _.cloneDeep(this.userForm)
        form.password = encrypt(form.password)
        form.referrer = localStorage.getItem('referrer') || undefined
        form.equipment = 'mobile'
        form.area = ''

        // 如果用户是平台引流进入kakaclo，注册的时候带上推广码,来源
        if (this.$store.state.common.promotionCode) {
          form.inviteCode = this.$store.state.common.promotionCode
          form.userSource = this.$store.state.common.promotionSource
        }

        if (this.loginMethod === 'email') {
          delete form.phone
        } else {
          delete form.email
          form.phone = `${this.areaCode} ${form.phone}`
        }

        form.questionnaireAnswers = JSON.stringify({
          questions: this.questions,
          business: this.business
        })
        this.loading = true
        API.signIn(form)
          .then(res => {
            if (res.code === 10000) {
              this.$message.success(this.$t('promptText.msg32'))
              // 保存登录信息
              let userinfo = {
                pwd: form.password,
                type: this.loginMethod
              }
              // this.loginMethod !== 'email' ? userinfo.phone = this.userForm.phone : userinfo.name = this.userForm.email
              // if (this.loginMethod !== 'email') userinfo.code = this.areaCode

              if (this.loginMethod !== 'email') {
                userinfo.phone = userinfo.name = this.userForm.phone
                userinfo.areaCode = userinfo.code = this.areaCode
              } else {
                userinfo.name = this.userForm.email
              }
              localStorage.setItem('remeberPassword', JSON.stringify(userinfo))
              this.toSignIn()
            } else {
              this.$message.error(res.message)
            }
          })
          .catch(result => {
            this.$message.error(result.data.message)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    toSignIn() {
      this.$router.push('/login?from=register&autoLogin=1')
    },
    jump(path) {
      location.href = path
    }
  }
}
</script>

<style lang="scss" scoped>

.mobile {
    width: 100%;
    height: 100vh;
    position: relative;

    .mobile-register {
        width: 90%;
        position: absolute;
        left: 5%;
        .close {
            height: 48px;
            line-height: 48px;
            text-align: right;
            i, i:active {
                font-size: 24px;
                color: #303133;
                display: inline-block;
            }
        }
        .close span {
            cursor: pointer;
            color: #303133;
            font-size: 16px;
        }
        .return {
            img {
                width: 24px;
                height: 24px;
                margin-top: 12px;
                cursor: pointer;
            }
        }
        .signin {
            text-align: center;
            font-weight: 400;
            font-size: 14px;
        }
        .signin h4 {
            font-size: 24px;
            font-weight: bold;
            color: #303133;
            padding: 24px 0;
        }
        .signin p {
            color: #909399;
            padding-bottom: 24px;
        }
        .login {
            color: #9AC331
        }
        .step-tab {
          .item {
            width: 50%;
            height: 34px;
            box-sizing: border-box;
            border-bottom: 4px solid #F5F9EA;
            color: #909399;
            font-size: 12px;
          }
          .sel {
            border-bottom: 4px solid #9AC331;
          }
        }
        .register-question {
          margin-top: 24px;
        }
        .register-btn {
          width: 100%;
          height: 40px;
          border-radius: 2px;
        }
        .referrer /deep/ input {
            cursor: pointer;
        }
        .terms {
          text-align: center;
          font-size: 12px;
          line-height: 18px;
          margin-top: 20px;
          .showError {
            /deep/ .el-checkbox__inner {
              border: 1px solid #F56C6C;
            }
          }
          /deep/ .el-checkbox {
            margin: 0;
            margin-right: 2px;
          }
        }
        .phone /deep/ .el-input__inner {
            border-top-left-radius: 0;
            border-top-right-radius: 2px;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 2px;
        }
        /deep/.el-input__inner {
            border-radius:4px !important;
            height: 44px;
            margin-top: 8px;
        }
        .phone {
          height: unset !important;
        }
        .username {
            display: flex;
            justify-content: center;
        }
        .login-mobile, .email {
            width: 100%;
        }
        .username /deep/ .el-form-item__content {
          width: 100%;
        }
        .areaCode {
            width: 88px;
        }
        .areaCode /deep/ .el-input__inner  {
            border: 1px solid #E1E4EA !important;
            border-right: 0 !important;
            border-top-left-radius: 4px !important;
            border-top-right-radius: 0 !important;
            border-bottom-left-radius: 4px !important;
            border-bottom-right-radius: 0 !important;
            color: #303133;
            font-size: 14px;
            cursor: pointer;
        }
        .el-icon-arrow-down {
            position: absolute;
            left: 84px;
            cursor: pointer;
        }
        .phone /deep/ .el-input__inner {
            border-top-left-radius: 0 !important;
            border-top-right-radius: 4px !important;
            border-bottom-left-radius: 0 !important;
            border-bottom-right-radius: 4px !important;
        }
        .phone /deep/ .el-form-item__error {
          left: -88px;
        }
        .send, .send:hover {
            height: 44px;
            background: #FFFFFF;
            color: #606266;
            position: absolute;
            top: 16%;
            right: 0;
            width: 25%;
        }
        .password /deep/ .el-input__suffix {
          top: 6px;
        }
        .verificationCode /deep/ .el-form-item__content {
          position: relative;
        }
        /deep/ .el-form-item {
          height: 52px;
        }
    }
}

</style>

